import HashScrolling from "../../../../src/scripts/hash-scrolling";

export default class CardGrid {
    static init() {
        // show all button
        document.addEventListener('click', function (event) {
            const cardGridShowAllButton = event.target.closest('.card-grid--show-only-few--show-all');
            if (!cardGridShowAllButton) {
                return;
            }

            const grid = cardGridShowAllButton.closest('.card-grid');
            if (!grid) {
                return;
            }

            const currentHeight = grid.offsetHeight;
            grid.classList.remove('card-grid--show-only-3');
            grid.classList.remove('card-grid--show-only-4');
            grid.classList.remove('card-grid--show-only-6');
            grid.classList.remove('card-grid--show-only-8');
            const finalHeight = grid.offsetHeight;
            grid.style.maxHeight = currentHeight + 'px';


            HashScrolling.scrollToLinkIfIsAbove(grid);

            setTimeout(() => {
                grid.style.maxHeight = finalHeight + 'px';
            }, 100);
            setTimeout(() => {
                event.target.closest('.card-grid--show-only-few--show-all').remove();
            }, 300);
            setTimeout(() => {
                grid.style.maxHeight = 'none';
            }, 2000);
        });

        CardGrid.calculateTextCardTitleHeights();
        window.addEventListener('resize', CardGrid.calculateTextCardTitleHeights);
    }

    static calculateTextCardTitleHeights() {
        const isMobile = window.innerWidth <= 768;
        const textCardGrid = document.querySelectorAll('.card-grid:has(.text-card)');
        Array.from(textCardGrid).forEach((grid) => {
            if (isMobile) {
                grid.style.setProperty('--text-card-title-height', '0');
                return;
            }
            grid.style.setProperty('--text-card-title-height', '0');
            const textCards = grid.querySelectorAll('.text-card .text-card__title');
            let maxHeight = 0;
            Array.from(textCards).forEach((textCard) => {
                maxHeight = Math.max(maxHeight, textCard.offsetHeight);
            });
            grid.style.setProperty('--text-card-title-height', maxHeight + 'px');
        });
    }
}
